import * as types from './mutation_types';
import { getDiscounts, getNotifications } from '../api/api'

export default {
  loadDegreePrograms({ commit }, degreePrograms) {
    commit(types.LOAD_DEGREE_PROGRAMS, degreePrograms)
  },
  loadMilitaryStatus({ commit }, militaryStatus) {
    commit(types.LOAD_MILITARY_STATUS, militaryStatus)
  },
  loadRegions({ commit }, regions) {
    commit(types.LOAD_REGIONS, regions)
  },
  loadDegreeOptions({ commit }, degreeOptions) {
    commit(types.LOAD_DEGREE_OPTIONS, degreeOptions)
  },
  loadCourseModality({ commit }, courseModality) {
    commit(types.LOAD_COURSE_MODALITY, courseModality)
  },
  loadSchoolSize({ commit }, schoolSize) {
    commit(types.LOAD_SCHOOL_SIZE, schoolSize)
  },
  loadHbcuOptions({ commit }, hbcuOptions) {
    commit(types.LOAD_HBCU_OPTIONS, hbcuOptions)
  },
  loadUserDegreeType({ commit }, userDegreeType) {
    commit(types.LOAD_USER_DEGREE_TYPE, userDegreeType)
  },
  loadNotifications({ commit }, params) {
    return getNotifications(params).then((response) => {
      commit(types.LOAD_NOTIFICATIONS, response.notifications);
    })
  },
  setUserSdnAgree({ commit }, userSdnAgree) {
    commit(types.SET_SDN_AGREE, userSdnAgree)
  },
  setDiscountNumber({ commit }) {
    return getDiscounts()
      .then((response) => {
        const activeItems = response.items.filter(item => item.application_status.status !== "canceled");
        commit(types.SET_DISCOUNT_NUMBER, activeItems.length);
      })
      .catch(() => {
        commit(types.SET_DISCOUNT_NUMBER, 0);
      });
  },
};
